import { createApp } from "vue";
import BulkApp from "../../vue/BulkApp.vue";

(function( $ ) {
	'use strict';

	 $(function() {

		var opengraphiqfontlist = [];
		var opengraphiqimageslist = [];

		var opengraphiqfontcounter = 0
		var opengraphiqimagecounter = 0

		var opengraphiqcounter = 0;

		var opengraphiqcurrentid;

		var opengraphiqnonce;
		
		window.opengraphiqinitializeBulk = function(){

			if( $('#bulkgenerate').length ){
				$('#bulkgenerate').one('click', (event) => {
					window.opengraphiqidlist = [];
					$( ".post-to-edit" ).each(function( index ) {
						window.opengraphiqidlist.push($(this).data("id"));
					});
					$("#bulkgenerate").hide();
					opengraphiqfetchpostdata();
				});
			};
		}

		window.opengraphiqfetchpostdata = function(){
			opengraphiqnonce = $( "#listwrapper" ).data( "nonce" );
			if (opengraphiqcounter < window.opengraphiqidlist.length){
				opengraphiqcurrentid = window.opengraphiqidlist[opengraphiqcounter];
				$(".post-to-edit[data-id='" + opengraphiqcurrentid + "']").append('<div class="og-ajax-result working">' + adminJStranslations.working + '</div>');
				jQuery.ajax({
					method : "POST",
					url : opengraphiqAjax.ajaxurl,
					data : {action: "bulk_ajax", og_template_nonce: opengraphiqnonce, id: opengraphiqcurrentid},
				}).done( function(msg) {
					opengraphiqcounter += 1;

					if ( msg == '{}' ){
						//$(".post-to-edit[data-id='" + opengraphiqcurrentid + "']").append('<div class="og-ajax-result cancelled">' + adminJStranslations.skipped + '</div>');
						$(".post-to-edit[data-id='" + opengraphiqcurrentid + "'] .og-ajax-result").removeClass("working").addClass("cancelled");
						$(".post-to-edit[data-id='" + opengraphiqcurrentid + "'] .og-ajax-result").html(adminJStranslations.skipped);
						opengraphiqfetchpostdata();
					} else {
						var opengraphiqfontarray = [];
						var opengrpahiqimagearray = [];
						
						var domobject = JSON.parse(msg);

						for (const domobj of domobject){
							
							if (domobj["type"] == 'text' || domobj["type"] == 'dyntext') {
								if(!(opengraphiqfontlist.includes(domobj["fontfamily"]))) {
									opengraphiqfontlist.push(domobj["fontfamily"]);
									opengraphiqfontarray.push(domobj["fontfamily"]);
								}
							}
							
							if (domobj["type"] == 'image' || domobj["type"] == 'dynimage') {
								var urlimg;
								if (domobj["type"] == 'image'){
									urlimg = domobj["src"];
								} else {
									urlimg = domobj["backgroundimage"];
								}

								if (!opengraphiqimageslist.includes(urlimg)){
									opengraphiqimageslist.push(urlimg);
									opengrpahiqimagearray.push(urlimg);
								}
							}
						}

						if(opengraphiqfontarray.length > 0) opengraphiqfontcounter = 1;
						opengraphiqimagecounter = opengrpahiqimagearray.length;

						if(opengraphiqfontcounter == 0 && opengraphiqimagecounter == 0){
							opengrpahiqlaodingfinished();
						} else {
							if(opengraphiqfontcounter > 0){
								var urlfont = opengraphiqbulkaddfont(opengraphiqfontarray);
								var stylesheet = jQuery("<link>", {
									rel: "stylesheet",
									type: "text/css",
									href: urlfont,
								});
								stylesheet.load(opengrpahiqcheckfontloaded);
								stylesheet.appendTo("head");
							}
		
							if(opengraphiqimagecounter > 0){
								for (var i = 0; i < opengrpahiqimagearray.length; i++) {
									var tempImage = new Image();
									
									tempImage.addEventListener("load", opengrpahiqcheckimageloaded, true);
									tempImage.src = opengrpahiqimagearray[i];
								}
							}
						}

					}

					function opengrpahiqcheckfontloaded(){
						opengraphiqfontcounter--;
						if (opengraphiqfontcounter == 0 && opengraphiqimagecounter == 0){
							opengrpahiqlaodingfinished();
						}
					}

					function opengrpahiqcheckimageloaded(e){
						opengraphiqimagecounter--;
						if (opengraphiqfontcounter == 0 && opengraphiqimagecounter == 0){
							opengrpahiqlaodingfinished();
						}
					}

					function opengrpahiqlaodingfinished(){
						opegraphiqbulksetdata(domobject);
					}
				});
			} else {
				// Dodati kod koji treba da zavrsi celu pricu
				$("#bulkfinished").show();
			}
		}

		window.opengraphmakeshot = function(){
			
			html2canvas(document.querySelector("#wrapper-inner"), {
				onclone: function (clonedDoc) {
					clonedDoc.querySelector("#wrapper-inner").style.visibility = 'visible';
					clonedDoc.querySelector("#wrapper-inner").classList.add('og-generate');
				},
				windowWidth : 1216,
				windowHeight: 600,
				}).then(canvas => {
					jQuery.ajax({
						method : "POST",
						url : opengraphiqAjax.ajaxurl,
						data : {action: "bulk_ajax_create_photo", og_template_nonce: opengraphiqnonce, id: opengraphiqcurrentid, photodata: canvas.toDataURL('image/jpeg', 0.8)},
					}).done( function(msg) {
						var domobject = JSON.parse(msg);
						$(".post-to-edit[data-id='" + opengraphiqcurrentid + "'] .og-ajax-result").removeClass("working").addClass("finished");
						$(".post-to-edit[data-id='" + opengraphiqcurrentid + "'] .og-ajax-result").html(adminJStranslations.finished);
						$(".post-to-edit[data-id='" + opengraphiqcurrentid + "']").append('<div class="og-ajax-final-img"><img src="' + domobject.ogurl + '" class="og-ajax-img"></div>');
						opengraphiqfetchpostdata();
					});
				});
		}

		window.opegraphiqbulksetdata = function(obj){
			app._component.data().store.domelements = obj;
		}

		window.opengraphiqbulkaddfont = function( fontarray ){
			var dynamlink = 'https://fonts.googleapis.com/css?family=';
			for (const fontfamily of fontarray){
				dynamlink += fontfamily + ':100,200,300,400,500,600,700,800,900,100italic,200italic,300italic,400italic,500italic,600italic,700italic,800italic,900italic|';
			}
			return dynamlink;
		}
		
		opengraphiqinitializeBulk();
		$("#bulkfinished").hide();
		$("#bulkfinished").on('click', function(){
			window.location.replace( $( "#listwrapper" ).data( "url" ) );
		});
		const app = createApp(BulkApp);
		app.mount("#opengraphiqpostcanvas");
	});

})( jQuery );
